var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent_leads"},[_c('app-loading-section',{attrs:{"loading":_vm.loading}},_vm._l((_vm.recentlyViewedLeads),function(record){return _c('app-record',{key:record.id,staticClass:"recently_viewed_lead",attrs:{"record":record,"tooltip-position":"is-left"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }